import React from 'react';
import {MDBContainer, MDBRow, MDBCol, MDBCard, MDBCardBody} from 'mdb-react-ui-kit';
import {Button} from 'react-bootstrap';

/**
 *  L'accueil
 * @param {*} props props
 * @return {JSX}
 */
function AddToDoListView(props) {
  return (
    <MDBContainer className="modal" fluid >
      <MDBRow className="d-flex justify-content-center align-items-center h-100 banktable-modal-content" style={{marginTop: '100px'}}>
        <MDBCol col="12">
          <MDBCard
            className="bg-dark text-white my-5 mx-auto align-items-center"
            style={{borderRadius: '1rem', maxWidth: '800px'}}>
            <span className="employe-close" onClick={props.closeModal} style={{marginRight: '20px', marginTop: '10px'}}>
            &times;
            </span>
            <h2 className="fw-bold mb-2 text-uppercase" style={{marginTop: '30px'}}>
            Ajouter une tâche
            </h2>
            <MDBCardBody className="mx-auto w-100 employer-padding">
              <textarea
                type="text"
                className="form-control"
                placeholder="Description de la tâche"
                style={{height: '100px'}}
                value={props.inputValue}
                onChange={(e) => props.setInputValue(e.target.value)} />
              {props.errors !== '' && (
                <span className="error">{props.errors}</span>
              )}
              <Button
                color="white"
                size="lg"
                style={{
                  color: 'white',
                  fontSize: 'calc(10px + 2vmin)',
                  backgroundColor: '#363E46',
                  border: 'none',
                  width: '100%',
                }}
                onClick={() => props.handleSubmit()}>
                Enregistrer
              </Button>
            </MDBCardBody>
          </MDBCard>
        </MDBCol>
      </MDBRow>
    </MDBContainer>
  );
}

export default AddToDoListView;
